/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_RecommendedInputs */

const en_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

const es_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const fr_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommandé`)
};

const de_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfohlen`)
};

const ja_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おすすめ`)
};

const zh_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

const ar_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موصى به`)
};

const id_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkomendasikan`)
};

const it_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigliati`)
};

const ru_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемые`)
};

const pt_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendados`)
};

const ko_search_sort_recommended = /** @type {(inputs: Search_Sort_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천순`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Search_Sort_RecommendedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_sort_recommended = /** @type {((inputs?: Search_Sort_RecommendedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_RecommendedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_sort_recommended(inputs)
	if (locale === "es") return es_search_sort_recommended(inputs)
	if (locale === "fr") return fr_search_sort_recommended(inputs)
	if (locale === "de") return de_search_sort_recommended(inputs)
	if (locale === "ja") return ja_search_sort_recommended(inputs)
	if (locale === "zh") return zh_search_sort_recommended(inputs)
	if (locale === "ar") return ar_search_sort_recommended(inputs)
	if (locale === "id") return id_search_sort_recommended(inputs)
	if (locale === "it") return it_search_sort_recommended(inputs)
	if (locale === "ru") return ru_search_sort_recommended(inputs)
	if (locale === "pt") return pt_search_sort_recommended(inputs)
	return ko_search_sort_recommended(inputs)
});